import { render, staticRenderFns } from "./live.vue?vue&type=template&id=de97ad9e&scoped=true"
import script from "./live.vue?vue&type=script&lang=js"
export * from "./live.vue?vue&type=script&lang=js"
import style0 from "./live.vue?vue&type=style&index=0&id=de97ad9e&prod&scoped=true&lang=less"
import style1 from "./live.vue?vue&type=style&index=1&id=de97ad9e&prod&lang=less"
import style2 from "./live.vue?vue&type=style&index=2&id=de97ad9e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de97ad9e",
  null
  
)

export default component.exports